export function AdminTabSkeleton() {
  return (
    <div className="space-y-4 animate-pulse">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="h-6 w-32 bg-muted rounded" />
        <div className="h-8 w-24 bg-muted rounded" />
      </div>

      {/* Table header */}
      <div className="bg-card border border-primary/10 rounded-xl overflow-hidden">
        <div className="flex gap-4 py-3 px-4 border-b border-primary/10 bg-muted/50">
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} className="h-4 flex-1 bg-muted rounded" />
          ))}
        </div>

        {/* Table rows */}
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} className="flex gap-4 py-3 px-4 border-b border-primary/10 last:border-0">
            {[1, 2, 3, 4, 5].map(j => (
              <div key={j} className="h-4 flex-1 bg-muted/50 rounded" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
